import { useState, useRef, useEffect } from 'react';
import { ResizeObserver as PolyfilledResizeObserver } from '@juggle/resize-observer';

const defaultOnResize = ({ width, height }) => ({ width, height });

export const useResize = (props) => {
  const { onResize = defaultOnResize, ref: propRef } = props ?? {};
  const defaultRef = useRef();
  const containerRef = propRef ?? defaultRef;

  const [aspects, setAspects] = useState({});

  const handleResize = ({ width, height }) => {
    const aspects = onResize({ width, height });

    setAspects(aspects);
  };

  useEffect(() => {
    const container = containerRef.current;

    if (!container) {
      return;
    }

    handleResize({
      width: container.clientWidth,
      height: container.clientHeight,
    });

    const ResizeObserver = window.ResizeObserver ?? PolyfilledResizeObserver;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;

        handleResize({ width, height });
      }
    });

    resizeObserver.observe(container);

    return () => {
      resizeObserver.unobserve(container);
    };
  }, [containerRef]);

  return {
    aspects,
    setAspects,
    ref: containerRef,
  };
};
